// ============================== User Types Helpers ==============================
// admin      => role based menus only
// superadmin => every operational screen
// support    => every operational screen + logs + app versions
// ================================================================================

export const USER_TYPES = {
  ADMIN: "admin",
  SUPER_ADMIN: "superadmin",
  SUPPORT: "support",
};

// Read the current user type from the store, with a localStorage fallback
export function getUserType(store) {
  const currentUser =
    store && store.getters ? store.getters["auth_module/currentUser"] : null;

  const userType =
    (currentUser && currentUser.usertype) ||
    localStorage.getItem("zoz_dash_User_Type") ||
    null;

  // Normalized so a different casing/spacing from the api still matches
  return userType ? String(userType).trim().toLowerCase() : null;
}

// `support` is the only user type allowed to open logs & app versions
export function isSupportUser(store) {
  return getUserType(store) === USER_TYPES.SUPPORT;
}

// `superadmin` & `support` see every operational screen without permissions
export function hasFullOpsAccess(store) {
  const userType = getUserType(store);
  return userType === USER_TYPES.SUPER_ADMIN || userType === USER_TYPES.SUPPORT;
}

export default {
  USER_TYPES,
  getUserType,
  isSupportUser,
  hasFullOpsAccess,
};
